import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '工作台' }
      },
      // 组织与场地
      {
        path: 'org/region',
        name: 'OrgRegion',
        component: () => import('@/views/org/region.vue'),
        meta: { title: '城市/区/街道管理' }
      },
      {
        path: 'org/venue',
        name: 'OrgVenue',
        component: () => import('@/views/org/venue.vue'),
        meta: { title: '场地管理' }
      },
      {
        path: 'org/venue/edit/:id?',
        name: 'OrgVenueEdit',
        component: () => import('@/views/org/venue-edit.vue'),
        meta: { title: '场地编辑' }
      },
      {
        path: 'org/principal',
        name: 'OrgPrincipal',
        component: () => import('@/views/org/principal.vue'),
        meta: { title: '主理人管理' }
      },
      // 课程管理
      {
        path: 'course/category',
        name: 'CourseCategory',
        component: () => import('@/views/course/category.vue'),
        meta: { title: '课程分类' }
      },
      {
        path: 'course/list',
        name: 'CourseList',
        component: () => import('@/views/course/list.vue'),
        meta: { title: '课程列表' }
      },
      {
        path: 'course/edit/:id?',
        name: 'CourseEdit',
        component: () => import('@/views/course/edit.vue'),
        meta: { title: '课程编辑' }
      },
      {
        path: 'course/class',
        name: 'CourseClass',
        component: () => import('@/views/course/class.vue'),
        meta: { title: '班级管理' }
      },
      {
        path: 'course/intention',
        name: 'CourseIntention',
        component: () => import('@/views/course/intention.vue'),
        meta: { title: '意向报名' }
      },
      // 活动管理
      {
        path: 'activity/category',
        name: 'ActivityCategory',
        component: () => import('@/views/activity/category.vue'),
        meta: { title: '活动分类' }
      },
      {
        path: 'activity/list',
        name: 'ActivityList',
        component: () => import('@/views/activity/list.vue'),
        meta: { title: '活动列表' }
      },
      {
        path: 'activity/edit/:id?',
        name: 'ActivityEdit',
        component: () => import('@/views/activity/edit.vue'),
        meta: { title: '活动编辑' }
      },
      {
        path: 'activity/signup',
        name: 'ActivitySignup',
        component: () => import('@/views/activity/signup.vue'),
        meta: { title: '报名/签到管理' }
      },
      // 用户管理
      {
        path: 'user/list',
        name: 'UserList',
        component: () => import('@/views/user/list.vue'),
        meta: { title: '用户列表' }
      },
      {
        path: 'user/feedback',
        name: 'UserFeedback',
        component: () => import('@/views/user/feedback.vue'),
        meta: { title: '意见反馈' }
      },
      // 预约管理
      {
        path: 'reservation/audit',
        name: 'ReservationAudit',
        component: () => import('@/views/reservation/audit.vue'),
        meta: { title: '预约审核' }
      },
      // 订单管理
      {
        path: 'order/list',
        name: 'OrderList',
        component: () => import('@/views/order/list.vue'),
        meta: { title: '订单列表' }
      },
      {
        path: 'order/refund',
        name: 'OrderRefund',
        component: () => import('@/views/order/refund.vue'),
        meta: { title: '退款审核' }
      },
      // 社区教联体
      {
        path: 'community/channel',
        name: 'CommunityChannel',
        component: () => import('@/views/community/channel.vue'),
        meta: { title: '栏目管理' }
      },
      {
        path: 'community/article',
        name: 'CommunityArticle',
        component: () => import('@/views/community/article.vue'),
        meta: { title: '内容管理' }
      },
      {
        path: 'community/article/edit/:id?',
        name: 'CommunityArticleEdit',
        component: () => import('@/views/community/article-edit.vue'),
        meta: { title: '文章编辑' }
      },
      {
        path: 'community/declaration',
        name: 'CommunityDeclaration',
        component: () => import('@/views/community/declaration.vue'),
        meta: { title: '申报配置' }
      },
      // 财务管理
      {
        path: 'finance/point-rule',
        name: 'FinancePointRule',
        component: () => import('@/views/finance/point-rule.vue'),
        meta: { title: '积分规则管理' }
      },
      {
        path: 'finance/point-flow',
        name: 'FinancePointFlow',
        component: () => import('@/views/finance/point-flow.vue'),
        meta: { title: '积分流水查询' }
      },
      {
        path: 'finance/point-exchange',
        name: 'FinancePointExchange',
        component: () => import('@/views/finance/point-exchange.vue'),
        meta: { title: '积分兑换管理' }
      },
      {
        path: 'finance/wallet',
        name: 'FinanceWallet',
        component: () => import('@/views/finance/wallet.vue'),
        meta: { title: '钱包流水查询' }
      },
      // 系统管理
      {
        path: 'system/admins',
        name: 'SystemAdmins',
        component: () => import('@/views/system/admins.vue'),
        meta: { title: '管理员管理' }
      },
      {
        path: 'system/roles',
        name: 'SystemRoles',
        component: () => import('@/views/system/roles.vue'),
        meta: { title: '角色管理' }
      },
      {
        path: 'system/config',
        name: 'SystemConfig',
        component: () => import('@/views/system/config.vue'),
        meta: { title: '系统配置' }
      },
      {
        path: 'system/dict',
        name: 'SystemDict',
        component: () => import('@/views/system/dict.vue'),
        meta: { title: '字典管理' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = getToken()
  if (to.path === '/login') {
    if (token) {
      next('/dashboard')
    } else {
      next()
    }
  } else {
    if (!token) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router
